import loanScopeDataHolder from "@/data/model/LoanScopeDataHolder";
import EzUtils from "@/utils/EzUtils";

export default {
  /***
   *
   * @returns {Map}
   */
  getRequiredDynamicFieldsData() {
    let stageFields = null;
    let requiredDynamicFields = null;
    if (loanScopeDataHolder.getCurrentLoanTask() != null && EzUtils.isNotEmpty(
      loanScopeDataHolder.getCurrentLoanTask().fields)) {
      stageFields = EzUtils.convertToJSONObjectIfString(
        loanScopeDataHolder.getCurrentLoanTask().fields);
    }

    if (stageFields != null) {
      requiredDynamicFields = {};
      stageFields && stageFields.forEach(stageField => {
        const fieldKey = stageField.field
        if (EzUtils.isValidString(fieldKey)) {
          let value = {};
          let fieldLabel = ''
          let fieldValidation = ''
          if (EzUtils.isValidString(stageField.fieldLabel)) {
            fieldLabel = stageField.fieldLabel
          }
          if (EzUtils.isValidString(stageField.validation)) {
            fieldValidation = stageField.validation
          }
          requiredDynamicFields[fieldKey] = { 'label': fieldLabel, 'validation': fieldValidation };
        }
      })
    }
    return requiredDynamicFields;
  },

  /***
   *
   * @param filledFieldsData - fields filled by user
   * @param allFieldsData - all fields data for a task
   * @returns  Array<String>: invalidFields
   */
  validateDynamicFields(filledFieldsData, allFieldsData) {
    return this.validateDynamicFieldsForRequiredFields(
      filledFieldsData,
      allFieldsData,
      this.getRequiredDynamicFieldsData()
    );
  },

  /***
   * @param filledFieldsData - Map<String, String> {fieldKey: fieldValue} - fields filled by user
   *
   * @param allFieldsData - Map<fieldKey, Object>- all fields data for a task
   *    Object -> {
   *    'label':'fieldLabel',
   *    'validation': 'validation',
   *    'fieldType' :'fieldType',
   *    'optional': true/false
   *    }
   *    // fieldType -> DROPDOWN, EDIT_FIELD, RADIO
   *
   * @param requiredFieldsData - required dynamic fields data
   *  Map<fieldKey, Object>- required dynamic fields data
   *      Object -> {
   *      'label':'fieldLabel',
   *      'validation': 'validationFromServer',
   *    }
   *
   * @returns Array<String>: invalidFields
   */
  validateDynamicFieldsForRequiredFields(filledFieldsData, allFieldsData, requiredFieldsData) {
    let invalidFields = []

    if (!requiredFieldsData) {
      // validate for all fields in allFieldsData
      if (allFieldsData && Object.keys(allFieldsData).length > 0) {
        const fieldKeys = Object.keys(allFieldsData);
        fieldKeys && fieldKeys.forEach(fieldKey => {
          if (filledFieldsData) {
            if (!this.validateForSingleField(
              filledFieldsData[fieldKey],
              allFieldsData[fieldKey]['validation'],
              allFieldsData[fieldKey]['fieldType'],
              allFieldsData[fieldKey]['optional']
            )) {
              invalidFields.push(fieldKey)
            }
          } else {
            invalidFields.push(fieldKey)
          }
        })
      }
    } else if (Object.keys(requiredFieldsData).length > 0) {
      //validate for only fields from stage fields
      const fieldKeys = Object.keys(requiredFieldsData);
      fieldKeys && fieldKeys.forEach(fieldKey => {
        if (filledFieldsData) {
          let validationRegex = requiredFieldsData[fieldKey]['validation'];
          let fieldType = requiredFieldsData[fieldKey]['fieldType'];
          let optional = requiredFieldsData[fieldKey]['optional'];

          if (allFieldsData && allFieldsData[fieldKey]) {
            if (!validationRegex) {
              validationRegex = allFieldsData[fieldKey]['validation'];
            }
            if (!fieldType) {
              fieldType = allFieldsData[fieldKey]['fieldType'];
            }
            if (!EzUtils.isBoolean(optional)) {
              optional = allFieldsData[fieldKey]['optional'];
            }
          }

          if (!this.validateForSingleField(
              filledFieldsData[fieldKey],
              validationRegex,
              fieldType,
              optional
          )) {
            invalidFields.push(fieldKey)
          }
        } else {
          invalidFields.push(fieldKey)
        }
      })
    } else {
      //No need to validate
    }

    return invalidFields
  },

  /***
   *
   * @param fieldValue
   * @param validationRegex - validation Regex(for edit field) or default value(For dropdown)
   * @param fieldType - DROPDOWN, EDIT_FIELD, RADIO, BUTTON
   * @param optional - is field optional
   * @returns {boolean}
   */

  validateForSingleField(fieldValue, validationRegex, fieldType, optional) {
    if (fieldValue) {
      if (FieldTypes.BUTTON === fieldType || FieldTypes.RADIO === fieldType) {
        return true;
      } else if (FieldTypes.DROPDOWN === fieldType) {
        return !EzUtils.areEqualString(fieldValue, validationRegex); // fieldValue ia not equal to --SELECT--
      } else if (FieldTypes.EDIT_FIELD === fieldType) {
        if (validationRegex) {
          return EzUtils.doesPatternMatch(validationRegex, fieldValue);
        } else {
          return EzUtils.isValidString(fieldValue.trim());
        }
      } else {
        // should not reach here
        return false;
      }
    } else {
      return optional;
    }
  },

  removeFromInvalidFieldsIfValidValue(
    invalidFieldsList, key, value,
    allFieldsData, requiredFieldsData
  ) {
    if (invalidFieldsList && invalidFieldsList.includes(key)) {
      let validationRegex = null;
      let fieldType = null;
      let optional = null; //do not set true or false

      if (requiredFieldsData && requiredFieldsData[key]) {
        validationRegex = requiredFieldsData[key]['validation'];
        fieldType = requiredFieldsData[key]['fieldType'];
        optional = requiredFieldsData[key]['optional'];
      }

      if (allFieldsData && allFieldsData[key]) {
        if (!validationRegex) {
          validationRegex = allFieldsData[key]['validation'];
        }
        if (!fieldType) {
          fieldType = allFieldsData[key]['fieldType'];
        }
        if (!EzUtils.isBoolean(optional)) {
          optional = allFieldsData[key]['optional'];
        }
      }

      if (this.validateForSingleField(
          value,
          validationRegex,
          fieldType,
          optional
      )) {
        invalidFieldsList.splice(invalidFieldsList.indexOf(key), 1)
      }
    }
    return invalidFieldsList
  },

  isFieldNeeded(fieldKey, dynamicFields) {
    if (!fieldKey) {
      return false;
    }
    return !dynamicFields || dynamicFields[key]
  },

  isFieldNeededToShow(fieldKey, dynamicFields) {
    if (!fieldKey) {
      return false;
    }

    if (!dynamicFields) {
      return true;
    }

    if (!dynamicFields[fieldKey]) {
      return false;
    }

    return EzUtils.isFalse(dynamicFields[fieldKey]["hide"]);
  },

  getFieldLabel(fieldKey, dynamicFields, allFields) {
    if (!fieldKey) {
      return "";
    }

    if (dynamicFields && dynamicFields[fieldKey]
        && dynamicFields[fieldKey]["label"]
    ) {
      return dynamicFields[fieldKey]["label"];
    }

    if (allFields && allFields[fieldKey] && allFields[fieldKey]["label"]) {
      return allFields[fieldKey]["label"];
    }

    return fieldKey;
  },

  getFieldValue(fieldKey, keyValueMap) {
    if (!fieldKey) {
      return "";
    }

    if (keyValueMap && keyValueMap[fieldKey]) {
      return keyValueMap[fieldKey];
    }
    return "";
  },

  showFieldError(fieldKey, invalidFields) {
    if (!fieldKey) {
      return false;
    }

    if (invalidFields && invalidFields.includes(fieldKey)) {
      return true;
    }

    return false;
  },

  getFieldErrorMsg(fieldKey, allFields) {
    if (!fieldKey) {
      return "";
    }

    if (allFields && allFields[fieldKey] && allFields[fieldKey]["errorMsg"]) {
      return allFields[fieldKey]["errorMsg"];
    }

    return "Enter valid " + this.getFieldLabel(fieldKey, null, allFields);
  }
};

export const FieldTypes = {
  DROPDOWN: "DROPDOWN",
  EDIT_FIELD: "EDIT_FIELD",
  RADIO: "RADIO",
  BUTTON: "BUTTON"
};
